import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'is_listed', label: 'Listed' },
  { key: 'ownership_percent', label: 'Ownership %', align: 'right', type: 'percent' },
  { key: 'nav_per_unit', label: 'NAV/Unit', align: 'right', type: 'money' },
  { key: 'unrealised_gain_loss', label: 'Unrealised G/L', align: 'right', type: 'money' },
  { key: 'dividend_yield', label: 'Dividend Yield', align: 'right', type: 'percent' },
  { key: 'total_return', label: 'Total Return', align: 'right', type: 'percent' },
  { key: 'concentration_percent', label: '% of Equity Book', align: 'right', type: 'percent' },
  { key: 'concentration_flag', label: 'Status' },
];

export function EquityConcentrationReport() {
  return (
    <ReportView
      title="Equity Holdings & Concentration"
      description="Every equity holding with NAV per unit, unrealised gain/loss, dividend yield, total return, and % of the total equity book — flagged over 25% concentration."
      endpoint="/reports/investments/equity-concentration"
      columns={COLUMNS}
      xlsx
    />
  );
}
